export default __webpack_public_path__ + "static/media/CapacitorTableImg.f8c9df4c.png";